<div class="mx-auto px-4 py-8">
  <div class="card mb-4">
    <div class="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-4">
      <h2 class="text-lg font-semibold m-0 text-surface-900 dark:text-surface-0">
        Gains réalisés par maintenance prédictive
      </h2>
      <div class="flex flex-wrap gap-2 justify-center md:justify-start w-full md:w-auto">
        <p-button
          size="small"
          *ngFor="let frame of timeFrames"
          [outlined]="activeTimeFrame !== frame"
          [label]="frame"
          [severity]="activeTimeFrame === frame ? 'primary' : 'secondary'"
          class="grow sm:grow-0"
        ></p-button>
      </div>
    </div>
    

    <div class="grid grid-cols-12 gap-4 grid-nogutter p-2 mb-6">
      <div class="col-span-12 md:col-span-4 p-2">
        <div class="border border-surface-200 dark:border-surface-600 p-4 rounded bg-blue-50 m-0 p-0">
          <p class="text-sm text-gray-500 mt-2 mb-2">Coûts évités</p>
          <p class="text-2xl font-bold text-blue-700 mt-2 mb-2">
            € {{ gainsData.costsAvoided | number : "1.0-0" }}
          </p>
          <p class="text-xs text-green-600 mt-2 mb-2">
            +{{ gainsData.costsGrowth }}% vs T4 2024
          </p>
        </div>
      </div>
      <div class="col-span-12 md:col-span-4 p-2">
        <div class="border border-surface-200 dark:border-surface-600 p-4 rounded bg-green-50">
          <p class="text-sm text-gray-500 mt-2 mb-2">Temps d'arrêt évité</p>
          <p class="text-2xl font-bold text-green-700 mt-2 mb-2">
            {{ gainsData.downtimeAvoided }} heures
          </p>
          <p class="text-xs text-green-600 mt-2 mb-2">
            +{{ gainsData.downtimeGrowth }}% vs T4 2024
          </p>
        </div>
      </div>
      <div class="col-span-12 md:col-span-4 p-2">
        <div class="border border-surface-200 dark:border-surface-600 p-4 rounded bg-purple-50">
          <p class="text-sm text-gray-500 mt-2 mb-2">ROI</p>
          <p class="text-2xl font-bold text-purple-700 mt-2 mb-2">{{ gainsData.roi }}%</p>
          <p class="text-xs text-green-600 mt-2 mb-2">
            +{{ gainsData.roiGrowth }}% vs T4 2024
          </p>
        </div>
      </div>
    </div>


    <div class="relative mt-4">
      <div *ngIf="isBrowser">
        <!-- <canvas baseChart
                    [data]="gainsChartData"
                    [options]="gainsChartOptions"
                    [type]="'bar'"
                    height="180">
                  </canvas> -->
      
                  <canvas baseChart
                  [data]="drilldownChartData"
                  [options]="drilldownChartOptions"
                  [type]="'pie'"
                  height="180">
                </canvas>
        </div>
    </div>

    <div class="flex md:justify-end justify-center flex-wrap gap-2 mt-4 grow">
      <p-button label="Voir par catégorie" (onClick)="showGainsByCategory()" severity="secondary" size="small"></p-button>
      <p-button
        label="Voir par équipement"
        size="small"
        (onClick)="showGainsByEquipment()"
      ></p-button>
    </div>
  </div>

</div>


